var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0014 1.66602C5.39898 1.66599 1.668 5.39693 1.66797 9.9993C1.66794 14.6017 5.39894 18.3327 10.0014 18.3327C14.6037 18.3327 18.3347 14.6017 18.3346 9.9993C18.3346 5.39697 14.6037 1.66605 10.0014 1.66602ZM13.328 6.99113C13.5402 6.99113 13.7524 7.0724 13.915 7.235C14.2402 7.56019 14.2402 8.08377 13.915 8.40896L9.56112 12.7628C9.41885 12.9051 9.2386 12.9852 9.05361 13.0029C8.81576 13.0258 8.57008 12.9458 8.38716 12.7628L6.0877 10.4635C5.76251 10.1383 5.76251 9.61467 6.0877 9.28949C6.41288 8.9643 6.93655 8.96429 7.26174 9.28949L8.97415 11.0019L12.741 7.235C12.9036 7.0724 13.1158 6.99113 13.328 6.99113Z",
    fill: "#3DC7A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOutlined);
export default __webpack_public_path__ + "static/media/check_outlined.3ba3132bd27a5f59be9682f4a6e2f546.svg";
export { ForwardRef as ReactComponent };